import { useEffect, useState } from "react";
import axios from "axios";
import swal from "sweetalert";
import "./game.css";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import Header from "../components/Header";

// Import Swiper React components và styles (Cú pháp chuẩn version 8)
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/swiper.min.css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import SwiperCore, { Autoplay, Navigation, Pagination } from "swiper/core";

function Esports() {
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false);
    const [profile, setProfile] = useState(null);
    const [playGame, setPlayGame] = useState(null);
    const [sanh, setSanh] = useState(null);
    const [product, setProduct] = useState(null);

    // State lưu trữ dữ liệu banner động từ API
    const [notify, setNotify] = useState(() => {
        const saved = localStorage.getItem("notify");
        return saved ? JSON.parse(saved) : [];
    });

    const autoRecoverMoney = (productType) => {
        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: productType })
            .then((res) => {
                const currentBalance = res.data.data.balance;
                if (currentBalance > 0) {
                    return axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, {
                        product_type: productType,
                        type: 2,
                        money: Math.floor(currentBalance)
                    });
                }
                return Promise.resolve();
            })
            .then(() => {
                localStorage.removeItem("playing_product");
                return axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`);
            })
            .then((res) => {
                if (res && res.data && res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
            })
            .catch((err) => console.log("Lỗi tự động thu hồi tiền phiên cũ:", err));
    };

    useEffect(() => {
        const interceptor = axios.interceptors.request.use(
            (config) => {
                const token = localStorage.getItem("user");
                if (token) {
                    config.headers["Authorization"] = `Bearer ${token}`;
                }
                return config;
            },
            (error) => Promise.reject(error)
        );

        // Lấy thông tin User
        axios
            .get(`${process.env.REACT_APP_API_URL}/auth/getUser`, {})
            .then((res) => {
                setProfile(res.data.data);
                localStorage.setItem("profile", JSON.stringify(res.data.data));

                const interruptedProduct = localStorage.getItem("playing_product");
                if (interruptedProduct) {
                    autoRecoverMoney(interruptedProduct);
                }
            })
            .catch((err) => localStorage.removeItem("user"));

        // Lấy dữ liệu Banner (Notify)
        axios.get(`${process.env.REACT_APP_API_URL}/auth/getnotify`, {})
            .then((res) => {
                if (JSON.stringify(notify) !== JSON.stringify(res.data.data)) {
                    setNotify(res.data.data);
                    localStorage.setItem("notify", JSON.stringify(res.data.data));
                }
            }).catch(() => {});

        return () => axios.interceptors.request.eject(interceptor);
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        const handlePopState = (event) => {
            if (playGame) handleCloseGame();
        };
        window.addEventListener("popstate", handlePopState);
        return () => window.removeEventListener("popstate", handlePopState);
    }, [playGame, product]);

    function isMobileDevice() {
        if (window.innerWidth < 800) return true;
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    function launchGame(params) {
        if (localStorage.getItem("profile") == null || localStorage.getItem("profile") === "undefined") {
            navigate("/login");
            return;
        }
        if (isLoading === true) return;

        const form = { ...params, platform: isMobileDevice() === true ? "html5" : "html5-desktop" };
        setLoading(true);

        let a;
        switch (params.product_type) {
            case "132": a = "SV388"; break;
            case "202": a = "WS168"; break;
            default: a = "Cock Fighting"; break;
        }
        setSanh(a);
        setProduct(params.product_type);

        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/launchgame`, form)
            .then((res) => {
                if (res.data.data.status === 0) {
                    const gameUrl = res.data.data.game_url;

                    if (profile && profile.money > 0) {
                        const amountToTransfer = Math.floor(profile.money);
                        const autoTransferData = {
                            product_type: params.product_type,
                            type: 1,
                            money: amountToTransfer
                        };

                        axios
                            .post(`${process.env.REACT_APP_API_URL}/casino/transfer`, autoTransferData)
                            .then(() => {
                                axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`).then((userRes) => {
                                    setProfile(userRes.data.data);
                                    localStorage.setItem("profile", JSON.stringify(userRes.data.data));
                                    localStorage.setItem("playing_product", params.product_type);
                                    window.history.pushState({ inGame: true }, "");
                                    setPlayGame(gameUrl);
                                    setLoading(false);
                                });
                            })
                            .catch((err) => {
                                localStorage.setItem("playing_product", params.product_type);
                                window.history.pushState({ inGame: true }, "");
                                setPlayGame(gameUrl);
                                setLoading(false);
                            });
                    } else {
                        localStorage.setItem("playing_product", params.product_type);
                        window.history.pushState({ inGame: true }, "");
                        setPlayGame(gameUrl);
                        setLoading(false);
                    }
                } else {
                    setLoading(false);
                    swal("Sảnh đang bảo trì", "Vui lòng chọn sảnh khác", "error");
                }
            })
            .catch((err) => {
                setLoading(false);
                if (err.response?.data?.data?.tokenVerificationData?.access === false) {
                    swal("Đã xảy ra lỗi", "Vui lòng đăng xuất và đăng nhập lại", "error");
                    return;
                }
                swal("Thất bại", err.response?.data?.message !== "internal server error" ? err.response?.data?.message : "Đã có lỗi xảy ra", "error");
            });
    }

    const handleCloseGame = () => {
        setLoading(true);
        axios
            .post(`${process.env.REACT_APP_API_URL}/casino/getbalance`, { product_type: product })
            .then((res) => {
                const currentBalance = res.data.data.balance;
                if (currentBalance > 0) {
                    const autoWithdrawData = {
                        product_type: product, type: 2, money: Math.floor(currentBalance)
                    };
                    return axios.post(`${process.env.REACT_APP_API_URL}/casino/transfer`, autoWithdrawData);
                }
                return Promise.resolve();
            })
            .then(() => axios.get(`${process.env.REACT_APP_API_URL}/auth/getUser`))
            .then((res) => {
                if (res && res.data && res.data.data) {
                    setProfile(res.data.data);
                    localStorage.setItem("profile", JSON.stringify(res.data.data));
                }
                localStorage.removeItem("playing_product");
                setPlayGame(null);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                setPlayGame(null);
                swal("Thông báo", "Hệ thống đang xử lý lệnh kết toán muộn. Vui lòng kiểm tra lại số dư ví tổng sau ít phút.", "warning");
            });
    };

    // Cấu hình cho Swiper banner
    const swiperParams = {
        modules: [Autoplay, Pagination],
        spaceBetween: 0,
        slidesPerView: 1,
        loop: true,
        autoplay: {
            delay: 3500,
            disableOnInteraction: false,
        },
        pagination: { clickable: true },
    };

    return (
        <>
            <Header profile={profile} />
            
            <style>{`
                /* NỀN DARK THEME */
                .cock-page-wrapper {
                    background-color: #1b1e36;
                    min-height: 100vh;
                    font-family: 'Montserrat', sans-serif;
                    padding-bottom: 50px;
                }

                /* BANNER ĐỘNG & TĨNH FULL WIDTH */
                .main-banner-wrap {
                    width: 100%;
                    overflow: hidden;
                    margin-bottom: 10px;
                }
                .swiper-pagination-bullet { background: #fff; opacity: 0.5; }
                .swiper-pagination-bullet-active { background: #00e5ff; opacity: 1; }

                .cock-banner-container {
                    width: 100%;
                    overflow: hidden;
                    display: flex;
                    justify-content: center;
                    background-color: #111429;
                    margin-bottom: 30px;
                }
                .cock-banner-container img {
                    width: 100%;
                    max-width: 1400px;
                    height: auto;
                    display: block;
                    object-fit: cover;
                }

                /* CONTAINER CHÍNH */
                .cock-container {
                    max-width: 1200px;
                    margin: 0 auto;
                    padding: 0 15px 20px;
                }
                
                /* Layout dạng lưới 2 cột cho các thẻ ảnh Đá Gà */
                .cock-grid {
                    display: grid;
                    grid-template-columns: repeat(2, 1fr);
                    gap: 25px; 
                }
                
                /* Nút Đá Gà dạng Card - ĐÃ XÓA BOX SHADOW */
                .cock-image-btn {
                    width: 100%;
                    height: auto;
                    cursor: pointer;
                    display: block;
                    border-radius: 8px; /* Bo góc sắc nét */
                    transition: transform 0.3s ease, filter 0.3s ease;
                }
                
                /* Hiệu ứng nhấc lên và sáng ảnh khi hover */
                .cock-image-btn:hover {
                    transform: translateY(-5px);
                    filter: brightness(1.1);
                }
                
                @media (max-width: 768px) {
                    .cock-grid {
                        grid-template-columns: 1fr; /* Điện thoại thì hiện 1 cột */
                        gap: 15px;
                    }
                    .cock-banner-container {
                        margin-bottom: 15px;
                    }
                }
            `}</style>

            {isLoading === true && (
                <div className="loading">
                    <div className="loader"></div>
                </div>
            )}

            <div className="cock-page-wrapper">
                
                {/* BANNER ĐỘNG TỪ API */}
              {notify && notify.length > 0 && (
                <div className="main-banner-wrap">
                    <Swiper {...swiperParams}>
                        {notify.map((item, index) => {
                            // CHỈ HIỂN THỊ CÁC THÔNG BÁO CÓ VỊ TRÍ LÀ 'home' (BANNER TRANG CHỦ)
                            if (item.isShow === true && item.displayLocation === "home") {
                                return (
                                    <SwiperSlide key={index}>
                                        <img 
                                            alt={item.title ? item.title.replace(/[{}]+/g, "") : "Banner"} 
                                            src={item.image} 
                                            style={{ width: "100%", maxHeight: "500px", objectFit: "cover", display: "block" }} 
                                        />
                                    </SwiperSlide>
                                )
                            }
                            return null;
                        })}
                    </Swiper>
                </div>
            )}

            

                <div className="cock-container">

                    {/* Lưới các sảnh Đá Gà */}
                    <div className="cock-grid">
                        
                        {/* 1. SV388 */}
                        <img 
                            className="cock-image-btn" 
                            src="https://images.7087053.com/prod-images/game_icon/sv3688/bigImage/gcs__sports-sv3_1759336927694.avif" 
                            alt="SV388" 
                            onClick={() => launchGame({ product_type: "132", game_code: "SV3002" })} 
                        />

                      

                        {/* 4. WS168 */}
                        <img 
                            className="cock-image-btn" 
                            src="https://images.7087053.com/prod-images/game_icon/sv3688/bigImage/gcs__SPORTS-WS168_1762324366514.png" 
                            alt="WS168" 
                            onClick={() => launchGame({ product_type: "202", game_code: "WS1682" })} 
                        />

                    </div>
                </div>
            </div>

            {/* IFRAME HIỂN THỊ GAME */}
            {playGame && (
                <div 
                    className="iframe-game-backdrop" 
                    style={{ 
                        position: "fixed", top: 0, left: 0, width: "100vw", height: "100vh", 
                        backgroundColor: "#000", zIndex: 99999, display: "flex", flexDirection: "column"
                    }}
                >
                    <div style={{
                        width: "100%", height: "50px", backgroundColor: "#162a35", 
                        display: "flex", justifyContent: "space-between", alignItems: "center",
                        padding: "0 15px", boxSizing: "border-box"
                    }}>
                        <div style={{ color: "#ffcc00", fontWeight: "bold", fontSize: "18px", fontFamily: "sans-serif" }}>
                            Đá Gà {sanh}
                        </div>
                        <button 
                            onClick={handleCloseGame} 
                            style={{ 
                                display: "flex", alignItems: "center", justifyContent: "center", gap: "4px",
                                backgroundColor: "#ff5050", color: "#fff", border: "none",
                                borderRadius: "20px", padding: "6px 16px", fontSize: "14px", fontWeight: "600", cursor: "pointer"
                            }}
                        >
                            <CloseIcon sx={{ fontSize: "18px" }} /> Thoát
                        </button>
                    </div>
                    <iframe 
                        src={playGame} 
                        title={`Game ${sanh}`}
                        style={{ width: "100%", flexGrow: 1, border: "none" }} 
                        allowFullScreen
                    ></iframe>
                </div>
            )}
        </>
    );
}

export default Esports;